/**
 * Textos do formulário de contacto (labels, departamentos, erros).
 * Centralizado para manter o componente enxuto e pronto para i18n.
 */

const baseErrors = (strings) => ({
  nameMin: strings.nameMin,
  nameMax: strings.nameMax,
  email: strings.email,
  department: strings.department,
  phone: strings.phone,
  messageMin: strings.messageMin,
  messageMax: strings.messageMax
});

export const CONTACT_FORM_COPY = {
  'pt-BR': {
    departmentLabel: 'Departamento',
    departmentPlaceholder: 'Selecione o departamento',
    deptInfo: 'Informações gerais',
    deptSupport: 'Suporte',
    deptSales: 'Vendas',
    phoneLabel: 'Telefone',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: 'Mínimo 20 caracteres.',
    sending: 'Enviando...',
    submitError: 'Não foi possível enviar a mensagem. Tente novamente.',
    networkError: 'Erro de rede. Verifique a sua ligação.',
    errors: baseErrors({
      nameMin: 'Indique pelo menos 2 caracteres.',
      nameMax: 'Nome demasiado longo (máx. 120).',
      email: 'Introduza um e-mail válido.',
      department: 'Selecione um departamento.',
      phone: 'Número de telefone inválido para o país selecionado.',
      messageMin: 'A mensagem deve ter pelo menos 20 caracteres.',
      messageMax: 'Máximo de 5000 caracteres.'
    })
  },
  'pt-PT': {
    departmentLabel: 'Departamento',
    departmentPlaceholder: 'Selecione o departamento',
    deptInfo: 'Informações gerais',
    deptSupport: 'Suporte',
    deptSales: 'Vendas',
    phoneLabel: 'Telefone',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: 'Mínimo 20 caracteres.',
    sending: 'A enviar...',
    submitError: 'Não foi possível enviar a mensagem. Tente novamente.',
    networkError: 'Erro de rede. Verifique a sua ligação.',
    errors: baseErrors({
      nameMin: 'Indique pelo menos 2 caracteres.',
      nameMax: 'Nome demasiado longo (máx. 120).',
      email: 'Introduza um e-mail válido.',
      department: 'Selecione um departamento.',
      phone: 'Número de telefone inválido para o país selecionado.',
      messageMin: 'A mensagem deve ter pelo menos 20 caracteres.',
      messageMax: 'Máximo de 5000 caracteres.'
    })
  },
  en: {
    departmentLabel: 'Department',
    departmentPlaceholder: 'Select a department',
    deptInfo: 'General information',
    deptSupport: 'Support',
    deptSales: 'Sales',
    phoneLabel: 'Phone',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: 'Minimum 20 characters.',
    sending: 'Sending...',
    submitError: 'Could not send your message. Please try again.',
    networkError: 'Network error. Check your connection.',
    errors: baseErrors({
      nameMin: 'Enter at least 2 characters.',
      nameMax: 'Name is too long (max. 120).',
      email: 'Enter a valid email address.',
      department: 'Select a department.',
      phone: 'Invalid phone number for the selected country.',
      messageMin: 'Message must be at least 20 characters.',
      messageMax: 'Maximum 5000 characters.'
    })
  },
  es: {
    departmentLabel: 'Departamento',
    departmentPlaceholder: 'Seleccione un departamento',
    deptInfo: 'Información general',
    deptSupport: 'Soporte',
    deptSales: 'Ventas',
    phoneLabel: 'Teléfono',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: 'Mínimo 20 caracteres.',
    sending: 'Enviando...',
    submitError: 'No se pudo enviar el mensaje. Inténtelo de nuevo.',
    networkError: 'Error de red. Compruebe su conexión.',
    errors: baseErrors({
      nameMin: 'Indique al menos 2 caracteres.',
      nameMax: 'Nombre demasiado largo (máx. 120).',
      email: 'Introduzca un correo válido.',
      department: 'Seleccione un departamento.',
      phone: 'Número de teléfono no válido para el país seleccionado.',
      messageMin: 'El mensaje debe tener al menos 20 caracteres.',
      messageMax: 'Máximo 5000 caracteres.'
    })
  },
  fr: {
    departmentLabel: 'Département',
    departmentPlaceholder: 'Sélectionnez un département',
    deptInfo: 'Informations générales',
    deptSupport: 'Support',
    deptSales: 'Ventes',
    phoneLabel: 'Téléphone',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: 'Minimum 20 caractères.',
    sending: 'Envoi...',
    submitError: 'Impossible d’envoyer le message. Réessayez.',
    networkError: 'Erreur réseau. Vérifiez votre connexion.',
    errors: baseErrors({
      nameMin: 'Saisissez au moins 2 caractères.',
      nameMax: 'Nom trop long (max. 120).',
      email: 'Saisissez une adresse e-mail valide.',
      department: 'Sélectionnez un département.',
      phone: 'Numéro de téléphone invalide pour le pays sélectionné.',
      messageMin: 'Le message doit contenir au moins 20 caractères.',
      messageMax: 'Maximum 5000 caractères.'
    })
  },
  it: {
    departmentLabel: 'Reparto',
    departmentPlaceholder: 'Seleziona un reparto',
    deptInfo: 'Informazioni generali',
    deptSupport: 'Supporto',
    deptSales: 'Vendite',
    phoneLabel: 'Telefono',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: 'Minimo 20 caratteri.',
    sending: 'Invio in corso...',
    submitError: 'Impossibile inviare il messaggio. Riprovare.',
    networkError: 'Errore di rete. Controllare la connessione.',
    errors: baseErrors({
      nameMin: 'Inserire almeno 2 caratteri.',
      nameMax: 'Nome troppo lungo (max 120).',
      email: 'Inserire un indirizzo e-mail valido.',
      department: 'Selezionare un reparto.',
      phone: 'Numero di telefono non valido per il paese selezionato.',
      messageMin: 'Il messaggio deve contenere almeno 20 caratteri.',
      messageMax: 'Massimo 5000 caratteri.'
    })
  },
  hi: {
    departmentLabel: 'विभाग',
    departmentPlaceholder: 'विभाग चुनें',
    deptInfo: 'सामान्य जानकारी',
    deptSupport: 'सहायता',
    deptSales: 'बिक्री',
    phoneLabel: 'फोन',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: 'कम से कम 20 अक्षर।',
    sending: 'भेजा जा रहा है...',
    submitError: 'संदेश नहीं भेजा जा सका। पुनः प्रयास करें।',
    networkError: 'नेटवर्क त्रुटि। कनेक्शन जांचें।',
    errors: baseErrors({
      nameMin: 'कम से कम 2 अक्षर दर्ज करें।',
      nameMax: 'नाम बहुत लंबा है (अधिकतम 120)।',
      email: 'वैध ईमेल दर्ज करें।',
      department: 'एक विभाग चुनें।',
      phone: 'चयनित देश के लिए अमान्य फोन नंबर।',
      messageMin: 'संदेश कम से कम 20 अक्षर का होना चाहिए।',
      messageMax: 'अधिकतम 5000 अक्षर।'
    })
  },
  de: {
    departmentLabel: 'Abteilung',
    departmentPlaceholder: 'Abteilung wählen',
    deptInfo: 'Allgemeine Informationen',
    deptSupport: 'Support',
    deptSales: 'Vertrieb',
    phoneLabel: 'Telefon',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: 'Mindestens 20 Zeichen.',
    sending: 'Wird gesendet...',
    submitError: 'Nachricht konnte nicht gesendet werden. Bitte erneut versuchen.',
    networkError: 'Netzwerkfehler. Verbindung prüfen.',
    errors: baseErrors({
      nameMin: 'Mindestens 2 Zeichen.',
      nameMax: 'Name zu lang (max. 120).',
      email: 'Gültige E-Mail-Adresse eingeben.',
      department: 'Bitte eine Abteilung wählen.',
      phone: 'Ungültige Telefonnummer für das gewählte Land.',
      messageMin: 'Nachricht mindestens 20 Zeichen.',
      messageMax: 'Maximal 5000 Zeichen.'
    })
  },
  nl: {
    departmentLabel: 'Afdeling',
    departmentPlaceholder: 'Selecteer een afdeling',
    deptInfo: 'Algemene informatie',
    deptSupport: 'Support',
    deptSales: 'Verkoop',
    phoneLabel: 'Telefoon',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: 'Minimaal 20 tekens.',
    sending: 'Verzenden...',
    submitError: 'Bericht kon niet worden verzonden. Probeer opnieuw.',
    networkError: 'Netwerkfout. Controleer uw verbinding.',
    errors: baseErrors({
      nameMin: 'Minimaal 2 tekens.',
      nameMax: 'Naam te lang (max. 120).',
      email: 'Voer een geldig e-mailadres in.',
      department: 'Selecteer een afdeling.',
      phone: 'Ongeldig telefoonnummer voor het gekozen land.',
      messageMin: 'Bericht minimaal 20 tekens.',
      messageMax: 'Maximaal 5000 tekens.'
    })
  },
  ru: {
    departmentLabel: 'Отдел',
    departmentPlaceholder: 'Выберите отдел',
    deptInfo: 'Общая информация',
    deptSupport: 'Поддержка',
    deptSales: 'Продажи',
    phoneLabel: 'Телефон',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: 'Минимум 20 символов.',
    sending: 'Отправка...',
    submitError: 'Не удалось отправить сообщение. Повторите попытку.',
    networkError: 'Ошибка сети. Проверьте подключение.',
    errors: baseErrors({
      nameMin: 'Не менее 2 символов.',
      nameMax: 'Имя слишком длинное (макс. 120).',
      email: 'Введите корректный e-mail.',
      department: 'Выберите отдел.',
      phone: 'Неверный номер для выбранной страны.',
      messageMin: 'Сообщение — не менее 20 символов.',
      messageMax: 'Не более 5000 символов.'
    })
  },
  ar: {
    departmentLabel: 'القسم',
    departmentPlaceholder: 'اختر القسم',
    deptInfo: 'معلومات عامة',
    deptSupport: 'الدعم',
    deptSales: 'المبيعات',
    phoneLabel: 'الهاتف',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: '20 حرفًا كحد أدنى.',
    sending: 'جارٍ الإرسال...',
    submitError: 'تعذّر إرسال الرسالة. حاول مرة أخرى.',
    networkError: 'خطأ في الشبكة. تحقق من الاتصال.',
    errors: baseErrors({
      nameMin: 'أدخل حرفين على الأقل.',
      nameMax: 'الاسم طويل جدًا (120 كحد أقصى).',
      email: 'أدخل بريدًا إلكترونيًا صالحًا.',
      department: 'اختر قسمًا.',
      phone: 'رقم غير صالح للبلد المحدد.',
      messageMin: 'الرسالة يجب ألا تقل عن 20 حرفًا.',
      messageMax: '5000 حرفًا كحد أقصى.'
    })
  },
  'zh-CN': {
    departmentLabel: '部门',
    departmentPlaceholder: '请选择部门',
    deptInfo: '一般咨询',
    deptSupport: '支持',
    deptSales: '销售',
    phoneLabel: '电话',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: '至少 20 个字符。',
    sending: '发送中...',
    submitError: '无法发送，请重试。',
    networkError: '网络错误，请检查连接。',
    errors: baseErrors({
      nameMin: '至少 2 个字符。',
      nameMax: '姓名过长（最多 120 个字符）。',
      email: '请输入有效邮箱。',
      department: '请选择部门。',
      phone: '所选国家/地区的电话号码无效。',
      messageMin: '留言至少 20 个字符。',
      messageMax: '最多 5000 个字符。'
    })
  },
  'zh-TW': {
    departmentLabel: '部門',
    departmentPlaceholder: '請選擇部門',
    deptInfo: '一般諮詢',
    deptSupport: '支援',
    deptSales: '銷售',
    phoneLabel: '電話',
    messageCounter: (n) => `${n} / 5000`,
    messageMinHint: '至少 20 個字元。',
    sending: '傳送中...',
    submitError: '無法傳送，請再試一次。',
    networkError: '網路錯誤，請檢查連線。',
    errors: baseErrors({
      nameMin: '至少 2 個字元。',
      nameMax: '姓名過長（最多 120 個字元）。',
      email: '請輸入有效電子郵件。',
      department: '請選擇部門。',
      phone: '所選國家/地區的電話號碼無效。',
      messageMin: '留言至少 20 個字元。',
      messageMax: '最多 5000 個字元。'
    })
  }
};

export function getContactFormCopy(language) {
  return CONTACT_FORM_COPY[language] || CONTACT_FORM_COPY['pt-BR'];
}

export function defaultCountryFromLanguage(language) {
  const map = {
    'pt-BR': 'BR',
    'pt-PT': 'PT',
    en: 'US',
    es: 'ES',
    fr: 'FR',
    it: 'IT',
    hi: 'IN',
    de: 'DE',
    nl: 'NL',
    ru: 'RU',
    ar: 'SA',
    'zh-CN': 'CN',
    'zh-TW': 'TW'
  };
  return map[language] || 'BR';
}
